import React, { PropTypes } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Field, reduxForm, change as changeFieldValue } from "redux-form";
import { FormattedMessage, intlShape } from "react-intl";

import { TextInput } from "../../../../../common/form";

import validationUtils from "../../../../../../utils/ValidationUtils";

const Ledgers = [
  "acombaGstNumber",
  "acombaQstNumber",
  "acombaHstNumber",
  "acombaPremiumNumber",
  "acombaFeeNumber",
  "acombaReserveNumber",
  "acombaReceivableNumber",
  "acombaPayableNumber",
];
let Insurers = [];
const Provinces = [
  "QC",
  "ON",
  "AB",
  "BC",
  "MB",
  "NB",
  "NL",
  "NS",
  "NT",
  "NU",
  "PE",
  "SK",
  "YT",
];

class BlocSettingsForm extends React.Component {
  static generateRules(insurers) {
    let rules = {};
    const commonRules = {
      isRequiredTrim: {
        value: true,
      },
      maxLength: {
        value: 7,
      },
    };

    Ledgers.map((field) => {
      rules[field] = commonRules;
    });

    Provinces.map((field) => {
      rules[`acombaTaxes['CA-${field}']`] = commonRules;
    });

    insurers.map((field) => {
      rules[`acombaInsurers['${field}']`] = {
        ...commonRules,
        maxLength: {
          value: 8,
        },
      };
    });

    return rules;
  }

  constructor(props, context) {
    super(props, context);

    this.renderButtons = this.renderButtons.bind(this);
    this.resetForm = this.resetForm.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.loaded && this.props.loaded) {
      this.resetForm();
    }
  }

  renderButtons() {
    const { pristine, submitting } = this.props;
    return (
      <span className="buttons">
        <button
          className="btn btn-primary"
          type="submit"
          disabled={pristine || submitting}
        >
          <FormattedMessage id="common.save" />
        </button>
        <button
          className="btn btn-default"
          type="button"
          onClick={this.resetForm}
        >
          <FormattedMessage id="common.cancel" />
        </button>
      </span>
    );
  }

  resetForm() {
    const { initialize, initialValues } = this.props;

    initialize(initialValues);
  }

  render() {
    const { authLanguageCode, handleSubmit, insurers, onSubmit } = this.props;

    return (
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="standalone-form acomba-settings"
      >
        {this.renderButtons()}

        <h2>
          <FormattedMessage id="admin.blocs.bloc.settings.form.titles.ledger" />
        </h2>
        <div className={"sub-section"}>
          {Ledgers.map((field) => {
            return (
              <Field
                key={field}
                id={field}
                name={field}
                type={"number"}
                maxLength="7"
                component={TextInput}
                label={
                  <FormattedMessage
                    id={`admin.blocs.bloc.settings.form.ledgers.${field}`}
                  />
                }
              />
            );
          })}
        </div>

        <h2>
          <FormattedMessage id="admin.blocs.bloc.settings.form.titles.taxes" />
        </h2>
        <div className={"sub-section"}>
          {Provinces.map((field) => {
            return (
              <Field
                key={field}
                id={`acombaTaxes['CA-${field}']`}
                name={`acombaTaxes['CA-${field}']`}
                type={"number"}
                maxLength="7"
                component={TextInput}
                label={<FormattedMessage id={`common.provinces.${field}`} />}
              />
            );
          })}
        </div>

        <h2>
          <FormattedMessage id="admin.blocs.bloc.settings.form.titles.insurers" />
        </h2>
        <div className={"sub-section"}>
          {insurers.map((field) => {
            let id = field.insurerId;
            return (
              <Field
                key={"insurer" + id}
                id={`acombaInsurers['${id}']`}
                name={`acombaInsurers['${id}']`}
                type={"number"}
                maxLength="8"
                component={TextInput}
                label={field.localizations[authLanguageCode].name}
              />
            );
          })}
        </div>

        {this.renderButtons()}
      </form>
    );
  }
}

BlocSettingsForm.propTypes = {
  authLanguageCode: PropTypes.string.isRequired,
  handleSubmit: PropTypes.func,
  initialize: PropTypes.func,
  initialValues: PropTypes.object.isRequired,
  insurers: PropTypes.array.isRequired,
  loaded: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
  pristine: PropTypes.bool,
  submitting: PropTypes.bool,
};

BlocSettingsForm.contextTypes = {
  intl: intlShape,
};

function mapStateToProps(state, ownProps) {
  Insurers = ownProps.insurers.map((i) => i.insurerId);
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    changeFieldValue: bindActionCreators(changeFieldValue, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps, null, {
  withRef: true,
})(
  reduxForm({
    form: "blocSettingsForm",
    enableReinitialize: true,
    validate: (values) =>
      validationUtils.validate(
        values,
        BlocSettingsForm.generateRules(Insurers)
      ),
  })(BlocSettingsForm)
);



// WEBPACK FOOTER //
// ./src/components/dashboard/admin/blocs/bloc/settings/BlocSettingsForm.js